import { FC } from 'react';
import { useLocation, Location, Outlet } from 'react-router-dom';
import { getRightBlockIcon } from 'view/pages/auth/helpers';
import * as S from './styled';

const AuthLayout: FC = () => {
  const location: Location = useLocation();

  return (
    <S.Wrapper>
      <S.LeftBlock>
        <Outlet />
      </S.LeftBlock>
      <S.RightBlock>{getRightBlockIcon(location)}</S.RightBlock>
    </S.Wrapper>
  );
};

export default AuthLayout;
